import React, { Fragment, useState } from "react";
import style from "../../../scss/modal.module.scss";
import { Modal } from "react-bootstrap";
import SelectComponent from "../../../components/SelectComponent";
import SelectLiderComponent from "../../../components/SelectLiderComponent";
import AlertComponent from "../../../components/AlertComponent";
import { crearElectores, editarElector } from "../../../Api/ApiMetodo";
import useCatalogos from "../../../hooks/useCatalogos";
import { obtenerMensajeError } from "../../../utils/mensajeError";
import { MAX_COMPROMISO } from "../../../constants/compromiso";

const ModalComponent = (props) => {
  const { opcionesLugar, opcionesMesaDe } = useCatalogos({ incluirCandidatos: false });
  const {
    setShow,
    show,
    setCedula,
    setNombre,
    setApellido,
    setSelectedOptionlugar,
    setDireccion,
    setTelefono,
    nombre,
    apellido,
    cedula,
    selectedOptionlugar,
    selectedOptionmesa,
    setSelectedOptionmesa,
    lider,
    setLider,
    direccion,
    telefono,
    compromiso,
    setCompromiso,
    compromisoFecha,
    setCompromisoFecha,
    id,
    setMostraralert,
    setcolorAlert,
    setAlerta,
    onCambio,
  } = props;
  const handleClose = () => setShow(false);

  // las mesas dependen del lugar: al cambiarlo se vuelve a elegir la mesa
  const cambiarLugar = (valor) => {
    setSelectedOptionlugar(valor);
    setSelectedOptionmesa(null);
  };

  const mostrarAlerta = (color, mensaje) => {
    setMostraralert(true);
    setcolorAlert(color);
    setAlerta(mensaje);
    setTimeout(() => {
      setMostraralert(false);
    }, 3000);
  };

  const editarId = () => {
    editarElector(
      id,
      cedula,
      nombre,
      apellido,
      selectedOptionlugar,
      selectedOptionmesa,
      lider,
      direccion,
      telefono,
      compromiso,
      compromisoFecha,
    )
      .then((response) => {
        mostrarAlerta("alert-success", response.msg);
        setShow(false);
        // refresca la tabla sin recargar la página
        onCambio?.();
      })
      .catch((error) => {
        mostrarAlerta("alert-danger", obtenerMensajeError(error));
        setShow(false);
      });
  };

  return (
    <Fragment>
      <>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title className="w-100 text-center">EDITAR LECTOR</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-center">
              <div className={style.Registro}>
                <form className={style.formulario}>
                  <div className="row gy-4">
                    <div className="col-12 col-md-6">
                      <label htmlFor="cedula">Numero de cedula:</label>
                      <input
                        type="text"
                        id="cedula"
                        className="form-control"
                        value={cedula}
                        onChange={(e) => setCedula(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label htmlFor="nombre">Nombres:</label>
                      <input
                        type="text"
                        id="nombre"
                        className="form-control"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label htmlFor="apellido">Apellidos:</label>
                      <input
                        type="text"
                        id="apellido"
                        className="form-control"
                        value={apellido}
                        onChange={(e) => setApellido(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <SelectComponent
                        etiqueta="Lugar"
                        opciones={opcionesLugar}
                        onCambiar={cambiarLugar}
                        valor={selectedOptionlugar}
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <SelectComponent
                        etiqueta="Mesa"
                        opciones={opcionesMesaDe(selectedOptionlugar)}
                        onCambiar={setSelectedOptionmesa}
                        valor={selectedOptionmesa}
                        deshabilitado={!selectedOptionlugar}
                        placeholder={selectedOptionlugar ? "Seleccionar mesa" : "Primero elige el lugar"}
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label htmlFor="direccion">Direccion:</label>
                      <input
                        type="text"
                        id="direccion"
                        className="form-control"
                        value={direccion}
                        onChange={(e) => setDireccion(e.target.value)}
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label htmlFor="telefono">Telefono:</label>
                      <input
                        type="text"
                        id="telefono"
                        className="form-control"
                        value={telefono}
                        onChange={(e) => setTelefono(e.target.value)}
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      {/* lista de líderes existentes: evita el mismo líder escrito distinto */}
                      <SelectLiderComponent etiqueta="Líder" valor={lider} onCambiar={setLider} />
                    </div>
                    <div className="col-12">
                      <label htmlFor="compromiso">Compromiso:</label>
                      <textarea
                        id="compromiso"
                        className="form-control"
                        rows={3}
                        maxLength={MAX_COMPROMISO}
                        value={compromiso}
                        onChange={(e) => setCompromiso(e.target.value)}
                        placeholder="Compromiso adquirido con el votante (opcional)"
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label htmlFor="compromisoFecha">Fecha del compromiso (opcional):</label>
                      <input
                        type="date"
                        id="compromisoFecha"
                        className="form-control"
                        value={compromisoFecha}
                        onChange={(e) => setCompromisoFecha(e.target.value)}
                        disabled={!compromiso?.trim()}
                        title={compromiso?.trim() ? "Con fecha, aparece en la agenda" : "Escribe primero el compromiso"}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mt-3">
                    <button
                      type="button"
                      className="btn btn-primary me-6"
                      onClick={() => {
                        editarId();
                      }}
                    >
                      Guardar Cambios
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    </Fragment>
  );
};
export default ModalComponent;
